import React from "react";

import ArrowUp from "#/svg/arrow-up.svg";
import ArrowDown from "#/svg/arrow-down.svg";
import CloseButton from "#/svg/close-button-white.svg";

export default ({ onChange, visible }) => {
  return (
    <>
      <div
        className="simulator-overlay"
        style={{
          visibility: visible ? "visible" : "hidden",
          opacity: visible ? 1 : 0,
        }}
      >
        <div className="simulator-overlay__background"></div>
        <div className="simulator-overlay__top-indicators">
          <div className="simulator-overlay__indicators__item">
            <p>{window.backendVars.copy["Select scenario"]}</p>
            <ArrowUp />
          </div>

          <div className="simulator-overlay__top-indicators__right">
            <div className="simulator-overlay__indicators__item">
              <p>{window.backendVars.copy["Timeline"]}</p>
              <ArrowUp />
            </div>

            <div className="simulator-overlay__indicators__item">
              <p>
                {window.backendVars.copy["Press play"]}
                <br />
                {window.backendVars.copy["to run the timeline"]}
              </p>
              <ArrowUp />
            </div>
          </div>

          <div className="simulator-overlay__middle-indicator">
            <div className="simulator-overlay__indicators__item">
              <ArrowDown />
              <p>
                {window.backendVars.copy["Interact with the"]}
                <br />
                {window.backendVars.copy["highlighted nodes"]}
              </p>
            </div>
          </div>

          <div className="simulator-overlay__left-indicator">
            <div className="simulator-overlay__indicators__item">
              <p>
                {window.backendVars.copy["Hover on lines to"]}
                <br />
                {window.backendVars.copy["discover the value"]}
              </p>
              <ArrowDown />
            </div>
          </div>
        </div>
        <div className="simulator-overlay__message">
          <h4>{window.backendVars.copy["Welcome to CCE Visualiser"]}</h4>
          <p>{window.backendVars.copy["Please explore how climate"]}</p>
          <button
            onClick={() => onChange(false)}
            onTouchStartCapture={() => onChange(false)}
          >
            {window.backendVars.copy["Got it"]}
          </button>

          <div
            className="simulator-overlay__message__close-button"
            onClick={() => onChange(false)}
            onTouchStartCapture={() => onChange(false)}
          >
            <CloseButton />
          </div>
        </div>
      </div>
    </>
  );
};
